// Polyfill para módulo 'stream' do Node.js
// Usado por react-render-html/parse5 no browser

// Stub básico para stream.Writable usado por parse5
// parse5 precisa de stream.Writable.prototype
export const Writable = function Writable() {
  this.writable = true;
  this.writableEnded = false;
  this.writableFinished = false;
  this.writableObjectMode = false;
  this.writableHighWaterMark = 16384;
  this.writableLength = 0;
  this.writableCorked = 0;
  this.destroyed = false;
};

Writable.prototype.write = function(chunk, encoding, callback) {
  if (typeof encoding === 'function') {
    callback = encoding;
    encoding = null;
  }
  if (callback) callback();
  return true;
};

Writable.prototype.end = function(chunk, encoding, callback) {
  if (typeof encoding === 'function') {
    callback = encoding;
    encoding = null;
  }
  this.writableEnded = true;
  this.writableFinished = true;
  if (callback) callback();
  return this;
};

Writable.prototype.destroy = function(err) {
  this.destroyed = true;
  return this;
};

export const Readable = class Readable {
  constructor() {
    this.readable = true;
    this.readableEnded = false;
    this.readableFlowing = null;
    this.readableHighWaterMark = 16384;
    this.readableLength = 0;
    this.readableObjectMode = false;
    this.destroyed = false;
  }

  read(size) {
    return null;
  }

  destroy(err) {
    this.destroyed = true;
    return this;
  }
};

export const Transform = class Transform extends Writable {
  constructor() {
    super();
    this.readable = true;
  }
};

export const Duplex = class Duplex extends Readable {
  constructor() {
    super();
    this.writable = true;
  }
};

export default {
  Writable,
  Readable,
  Transform,
  Duplex,
};
